import axios from "axios";
import { getStoredLeadId } from "./leadIdCookie";

export const TRIAL_BOT_TYPES = {
  ROOFING: "roofing",
  RENOVATION: "renovation",
  REAL_ESTATE: "real_estate",
};

export const TRIAL_DUPLICATE_EMAIL_MESSAGE =
  "This email is already in use. Please use a different email or log in.";

export async function registerTrialAccount({ email, botType }) {
  const normalizedEmail = email.trim().toLowerCase();
  const response = await axios.post(
    `${process.env.REACT_APP_BACKEND_URL}/api/auth/register-account-trial`,
    {
      email: normalizedEmail,
      bot_type: botType,
      shock_marketing_lead_id: getStoredLeadId() || undefined,
    }
  );
  return response.data;
}

export function mapTrialSignupError(err, duplicateMessage = TRIAL_DUPLICATE_EMAIL_MESSAGE) {
  if (err.response?.data?.message === "The user already exists") {
    return duplicateMessage;
  }
  if (err.response?.data?.detail) {
    return err.response.data.detail;
  }
  if (err.response?.data?.message) {
    return err.response.data.message;
  }
  if (err.request) {
    return "Network error. Please check your connection and try again.";
  }
  return "An unexpected error occurred. Please try again.";
}
